import { ReactNode, useEffect, useState } from "react";

interface DelayRenderWrapperProps {
  children: ReactNode;
  delay: number; // milliseconds
}

export const DelayRenderWrapper = ({
  children,
  delay,
}: DelayRenderWrapperProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return isVisible ? <>{children}</> : null;
};
